/**
 * モバイル（<768px）専用の下部タブバー — チャット/ボードの2タブ。
 *
 * デスクトップの AppHeader 内 SegmentNav（md 以上のみ表示）と役割が重複しないよう、
 * こちらは md 以上では常に非表示（md:hidden）。Chat / Board 両ページの最下部に
 * flex の末尾要素として置く想定（fixed ではなく通常のドキュメントフローに乗せることで、
 * 本体コンテンツが自動的に縮んでタブバーに隠れないようにする）。
 */
import { Link, useLocation } from "react-router-dom"

/** 吹き出しアイコン（チャット）。デザイン正本のパス・線画準拠。 */
function ChatIcon() {
  return (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 5.5h16v10.5H9l-4 4V5.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  )
}

/** カンバン（3本の列）アイコン（ボード）。デザイン正本の rect 準拠。 */
function BoardIcon() {
  return (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="4.5" width="5" height="15" rx="1.4" stroke="currentColor" strokeWidth="1.8" />
      <rect x="9.5" y="4.5" width="5" height="10" rx="1.4" stroke="currentColor" strokeWidth="1.8" />
      <rect x="16" y="4.5" width="5" height="13" rx="1.4" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  )
}

const TABS = [
  { label: "チャット", to: "/", icon: <ChatIcon /> },
  { label: "ボード", to: "/board", icon: <BoardIcon /> },
]

export function BottomTabBar() {
  const { pathname } = useLocation()

  return (
    // 外側で bg-card ごと safe-area 分の余白を確保し、中の 56px はコンテンツ高さとして固定する
    // （iPhone のホームバー領域まで背景色を伸ばしつつ、タップ領域の高さは崩さない）。
    <div className="md:hidden shrink-0 bg-card border-t border-line pb-[env(safe-area-inset-bottom)]">
      <nav className="h-14 flex items-stretch" aria-label="画面切り替え">
        {TABS.map(({ label, to, icon }) => {
          const isActive = pathname === to
          return (
            <Link
              key={to}
              to={to}
              className={`relative flex-1 flex flex-col items-center justify-center gap-0.5 ${
                isActive ? "text-night" : "text-muted-foreground"
              }`}
              aria-current={isActive ? "page" : undefined}
            >
              {/* アクティブ時のみ上端中央に金バー */}
              {isActive && (
                <span
                  className="absolute top-0 left-1/2 -translate-x-1/2 h-0.5 w-[26px] rounded-full bg-gold"
                  aria-hidden="true"
                />
              )}
              {icon}
              <span className="text-[11px] leading-none">{label}</span>
            </Link>
          )
        })}
      </nav>
    </div>
  )
}
